export default "__VITE_ASSET__bY7n6H1h__"